<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">管理后台登录</h3>
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="用户名称"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :key="passwordType"
          ref="password"
          v-model="loginForm.password"
          :type="passwordType"
          placeholder="用户密码"
          name="password"
          tabindex="2"
          autocomplete="on"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <el-form-item prop="code">
        <span class="svg-container">
          <svg-icon icon-class="message" />
        </span>
        <el-input
          ref="code"
          v-model="loginForm.code"
          type="text"
          placeholder="验证码"
          name="code"
          tabindex="3"
          autocomplete="ff"
        />
        <span class="code-img" >
          <img @click="updatecode" :src="img"/>
        </span>
      </el-form-item>

      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">登录</el-button>

    </el-form>

  </div>
</template>

<script>
import { validUsername, validPassword } from '@/utils/validate'
import { Loading } from 'element-ui'
import { captcha } from '@/api/user'
import { Base64 } from 'js-base64'
import CryptoJS from 'crypto-js'

let loadingInstance = Loading.service();

export default {
  name: 'Login',
  components: { },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('用户名称必须是字母、数字、下划线组合，且长度6-12位'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!validPassword(value)) {
        callback(new Error('用户密码必须是字母、数字、下划线组合，且长度6-18位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        code:'',
        key:''
      },
	  checked:true,
	  keypassword:"abcdefg098,.",
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        code: [{ required: true, trigger: 'blur' }]
      },
      passwordType: 'password',
      loading: false,
      redirect: undefined,
      otherQuery: {},
      img:''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    loadingInstance.close()
    this.getCaptcha()
	this.getCookie()
  },
  mounted() {
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
  },
  destroyed() {

  },
  methods: {
    getCaptcha(){
      captcha().then(response => {
        this.img = response.data.img
        this.loginForm.key = response.data.key
    })
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    updatecode(){
        this.getCaptcha()
    },
    handleLogin() {
		var _this = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
            .then(() => {
			  //记住密码
			  //调用check选中方法
              _this.checkedPwd(this.loginForm.username,this.loginForm.password)
              this.$router.push({ path: _this.redirect || '/', query: _this.otherQuery })
              _this.loading = false
            })
            .catch(() => {
              _this.loading = false
            })
        } else {
          console.log('请输入正确的账号和密码')
          return false
        }
      })
    },
	checkedPwd(username,pwd){
		// 记住密码进行cookie存储和密码加密
		console.log(this.checked);
		if (this.checked){
			// base64 加密
			let base64Pwd=Base64.encode(pwd);
			// Encrypt 加密
			let cryptoJsPwd=CryptoJS.AES.encrypt(base64Pwd,this.keypassword).toString()
			// 账号密码保存天数
			this.setCookie(username,cryptoJsPwd,7)
		}else{
			// 清空
			this.clearCookie()
		}
	},
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
	// 设置cookie
	setCookie(c_name, c_pwd, exdays) {
	    var exdate = new Date(); // 获取时间
	    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
	    // 字符串拼接cookie
	    window.document.cookie = "username" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
	    window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
	},
	// 读取cookie
	getCookie: function() {
	    if (document.cookie.length > 0) {
	        //checked为true
	        this.checked=true
	        var arr = document.cookie.split('; ');
	        for (var i = 0; i < arr.length; i++) {
	            var arr2 = arr[i].split('=');
	            if (arr2[0] == 'username') {
	                this.loginForm.username = arr2[1];
	            } else if (arr2[0] == 'password') {
	                // Decrypt 解密
	                let bytes = CryptoJS.AES.decrypt(arr2[1],this.keypassword)
	                let originalText=bytes.toString(CryptoJS.enc.Utf8)
	                // base64解密
	                let pwd=Base64.decode(originalText)
	                this.loginForm.password = pwd;
	            }
	        }
	    }
	},
	// 清除cookie
	clearCookie: function() {
	    this.setCookie("", "", -1); // 修改2值都为空，天数为负1天就好了
	}
  }
}
</script>

<style lang="scss">
$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .code-img {
    position: absolute;
    right: 0px;
    top: 0px;
    cursor: pointer;
    user-select: none;
    height:47px;
  }
  .code-img img{
    height: 47px;
  }
  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
